exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-link[data-v-a77691ee]{border:1px solid #008fd9;padding:4px 8px;border-radius:3px;font-size:.7rem;color:#008fd9;display:inline-block}.btn-link[data-v-a77691ee]:hover{cursor:pointer;background-color:#008fd9;color:#fff}.desc[data-v-a77691ee]{font-size:.8rem;margin-top:4px;color:#787878}#file[data-v-a77691ee]{position:fixed;bottom:-100px;left:-100px}", ""]);

// exports
